import { createTheme } from "@mui/material";
import { grey } from "@mui/material/colors";

const palette = {
  background: {
    default: '#f4f6f8',
    paper: '#ffffff'
  },
  primary: {
    contrastText: '#ffffff',
    main: '#032251'
  },
  primaryLight: {
    contrastText: '#ffffff',
    main: '#003FA2'
  },
  secondary: {
    contrastText: '#ffffff',
    main: '#288FF9'
  },
  secondaryLight: {
    contrastText: '#ffffff',
    main: '#58D6F4'
  },
  default: {
    contrastText: 'black',
    main: '#f4f6f8'
  },
  text: {
    primary: '#172b4d',
    secondary: '#6b778c',
  },
};

const components = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        whiteSpace: 'pre-line'
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        borderRadius: 8,
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        backgroundSize: "cover",
        // backgroundImage: `url('${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/bg-index-0.png')`,
        backgroundPosition: "center",
        backgroundColor: grey[100],
        color: palette.primary.main,
        fontSize: 18,
        fontWeight: 'bold',
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontWeight: 400,
        fontSize: 18
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '8px 8px 8px 8px'
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: "12px !important",
        borderTop: "1px solid",
        borderColor: grey[200],
      }
    }
  },

};

const theme = createTheme({
  components: {
    ...components
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },

  palette: {
    ...palette
  },


  shadows: [
    'none',
    '0 0 0 1px rgba(63,63,68,0.05), 0 1px 2px 0 rgba(63,63,68,0.15)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 2px 2px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 3px 4px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 6px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 4px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 5px 8px -2px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 12px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 6px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 7px 16px -4px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 8px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 9px 18px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 10px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 11px 20px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 12px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 13px 22px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 14px 24px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 16px 28px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 18px 30px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 20px 32px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 22px 34px -8px rgba(0,0,0,0.25)',
    '0 0 1px 0 rgba(0,0,0,0.31), 0 24px 36px -8px rgba(0,0,0,0.25)'
  ],
  typography: {
    fontFamily: [
      'Montserrat',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 900,
      fontSize: 32,
      letterSpacing: '-0.24px'
    },
    h2: {
      fontWeight: 600,
      fontSize: 29,
      letterSpacing: '-0.24px'
    },
    h3: {
      fontWeight: 700,
      fontSize: 24,
      letterSpacing: '-0.06px'
    },
    h4: {
      fontWeight: 600,
      fontSize: 20,
      letterSpacing: '-0.06px'
    },
    h5: {
      fontWeight: 600,
      fontSize: 16,
      letterSpacing: '-0.05px'
    },
    h6: {
      fontWeight: 600,
      fontSize: 14,
      letterSpacing: '-0.05px'
    },
    overline: {
      fontWeight: 600
    },
    button: {
      fontWeight: 'bold'
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: 18
    },
    subtitle2: {
      color: '#288FF9',
      fontWeight: 500,
      fontSize: 14
    }
  }
});

export default theme;